import { render, staticRenderFns } from "./page_yw.vue?vue&type=template&id=1d69c546&"
import script from "./page_yw.vue?vue&type=script&lang=js&"
export * from "./page_yw.vue?vue&type=script&lang=js&"
import style0 from "./page_yw.vue?vue&type=style&index=0&id=1d69c546&prod&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\nmgkjcx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports